<template id="frequency_watch">
    <section class="central-background">
        <div>
            <div class="py-0 d-flex justify-content-center third-level-nav">
                <div class="horizontal-nav-bar rounded-top">
                    <div
                        class="d-flex bg-white rounded-top"
                        id="solution-tab"
                        role="tablist"
                        aria-orientation="horizontal"
                    >
                        <a
                            v-for="tab in tabs"
                            :class="`nav-link d-flex justify-content-between align-items-center ${
                                activeTab === tab.id ? 'active' : ''
                            } ${!allowedTabs.includes(tab.id) || !tab.show ? 'disabled-tab' : ''}`"
                            :id="`v-pills-${tab.id}`"
                            data-toggle="pill"
                            href="javascript:void(0)"
                            role="tab"
                            :key="tab.id"
                            aria-selected="true"
                            :disabled="!allowedTabs.includes(tab.id) || !tab.show"
                            @click="handleTabChange(tab)"
                        >
                            {{ tab.name }}
                        </a>
                        <div class="d-flex justify-content-start ms-auto py-2 px-3">
                            <button type="button" class="btn btn-primary" @click="goToReportCenter()">
                                Report Center
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-content" id="v-pills-tabContent">
                <div>
                    <section class="px-3 mb-2">
                        <div v-if="activeTab === ApplicationEnum.AxxessHospiceFE">
                            <FrequencyWatchHos
                                :application="ApplicationEnum.AxxessHospiceFE"
                                :get-frequency-watch-data="getFrequencyWatchData"
                            />
                        </div>
                        <div v-if="activeTab === ApplicationEnum.AgencyCore">
                            <FrequencyWatchHH
                                :application="ApplicationEnum.AgencyCore"
                                :get-frequency-watch-data="getFrequencyWatchData"
                            />
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<style src="./FrequencyWatch.scss"></style>
<script lang="ts" src="./FrequencyWatch.ts"></script>
